import React from "react";
import {FaHeart, FaRegHeart} from "react-icons/fa";
import apiEndpoints from "../../shared/apiEndpoints";
import {useSelector} from "../../../shared-services/redux-tiny";
import angularIntegration from "../../../angular-integration";
import useModalQueue from "../../topLayer/modals/useModalQueue";

const FavoritesTogglePDP = (props) => {
  const {size, setProduct, className = ""} = props;
  const {currentUser} = useSelector(state => state.session);
  const {pushToQueue} = useModalQueue();
  const {$broadcast} = angularIntegration;

  const opacity = {
    active: 1,
    inactive: 0.4
  };

  const toggle = () => {
    if (!currentUser?.id) {
      pushToQueue("LoginModal");
      return;
    }

    const {toggleFavorites} = apiEndpoints;

    toggleFavorites(props.product?.id).then(response => {
      const isFavorite = response?.data?.in_favorites || false;
      setProduct({...props.product, isFavorite});
      $broadcast("react:user:updated");
    });
  };

  return <div
    className={`
      flex
      align-items-center
      justify-content-flex-end
      cursor-pointer
      position-relative`
    }
    style={{width: size, height: size}}
    onClick={toggle}
  >
    <div
      className={`
        position-absolute
        flex
        align-items-center
        justify-content-center
        ${className}
      `}
      style={{
        width: size,
        height: size,
        fontSize: size
      }}
    >
      <FaRegHeart
        className="text-color-green position-absolute transition-all-default full-width"
        style={{opacity: props?.product?.isFavorite ? opacity.active : opacity.inactive}}
      />
      <FaHeart className={`
      text-color-green
      position-absolute
      transition-all-default
      full-width
    `} style={{
        height: `${props?.product?.isFavorite ? "100%" : 0}`,
        width: `${props?.product?.isFavorite ? "100%" : 0}`,
        opacity: 0.7
      }}/>
    </div>
  </div>;
};

export default FavoritesTogglePDP;
